var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-ons-navigator',{attrs:{"swipeable":"","page-stack":_vm.pageStack}})}
var staticRenderFns = []

export { render, staticRenderFns }